import Layout from '@/layout'

const itdailyRoutes = {
  path: '/itdaily',
  component: Layout,
  redirect: '/itdaily/ticket/list',
  name: '信息化日常',
  funcPerms: 'itdaily:manage',
  meta: { title: '信息化日常', icon: 'index', affix: false, noCache: true },
  children: [
    {
      path: 'ticket/list',
      component: () => import('@/views/itdaily/ticket/index'),
      funcPerms: 'itdaily:ticket',
      name: 'ItdailyTicket',
      meta: { title: 'IT工单', icon: 'list', noCache: true }
    },
    {
      path: 'receive/list',
      component: () => import('@/views/itdaily/receive/index'),
      funcPerms: 'itdaily:receive',
      name: 'ItdailyReceive',
      meta: { title: '领用登记', icon: 'list', noCache: true }
    },
    {
      path: 'affair/list',
      component: () => import('@/views/itdaily/affair/index'),
      funcPerms: 'itdaily:affair',
      name: 'ItdailyAffair',
      meta: { title: '事项台账', icon: 'list', noCache: true }
    },
    {
      path: 'serverInspect/list',
      component: () => import('@/views/itdaily/serverInspect/index'),
      funcPerms: 'itdaily:serverInspect',
      name: 'ItdailyServerInspect',
      meta: { title: '服务器巡检', icon: 'list', noCache: true }
    },
    {
      path: 'roomInspect/list',
      component: () => import('@/views/itdaily/roomInspect/index'),
      funcPerms: 'itdaily:roomInspect',
      name: 'ItdailyRoomInspect',
      meta: { title: '机房巡检', icon: 'list', noCache: true }
    },
    {
      path: 'computer/list',
      component: () => import('@/views/itdaily/computer/index'),
      funcPerms: 'itdaily:computer',
      name: 'ItdailyComputer',
      meta: { title: '中心计算机统计', icon: 'list', noCache: true }
    },
    {
      path: 'ip/list',
      component: () => import('@/views/itdaily/ip/index'),
      funcPerms: 'itdaily:ip',
      name: 'ItdailyIp',
      meta: { title: 'IP地址台账', icon: 'list', noCache: true }
    },
    {
      path: 'asset/list',
      component: () => import('@/views/itdaily/asset/index'),
      funcPerms: 'itdaily:asset',
      name: 'ItdailyAsset',
      meta: { title: '固定资产台账', icon: 'list', noCache: true }
    }
  ]
}

export default itdailyRoutes
